// extracted by mini-css-extract-plugin
module.exports = {"descriptionImageContainer":"i33oxP","textContainer":"_1tcrlM","imageContainer":"_163E9U","categoryImage":"_3KgsKT"};